function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15A1.502 1.502 0 003 4.5v15A1.502 1.502 0 004.5 21h10.19a1.491 1.491 0 001.06-.44l4.81-4.81a1.492 1.492 0 00.44-1.06V4.5A1.502 1.502 0 0019.5 3zM15 19.19V15h4.19L15 19.19z",
    fill: props.fill
  }));
}

export default SvgNote;